import React from "react";
import { Box, Grid, Typography, Card, CardMedia } from "@mui/material";
import hr from "../../assets/hr.jpeg";
import cse from "../../assets/cse.jpeg";

const testimonials = [
  {
    text: "Since starting at SalonTym in 2023, a key takeaway has been the foundation of work-life balance...",
    author: "Ankita Mishra",
    position: "Associate Director, Talent Acquisition",
    url: hr,
  },
  {
    text: "At SalonTym, our work environment and schedules don't have the constraints of a traditional job...",
    author: "Neha Mishra",
    position: "Customer Support Executive, Operation Dept.",
    url: cse,
  },
];

const WorkLifeBalance = () => {
  return (
    <Box sx={{ margin: "auto", padding: { xs: "0px", sm: "2rem" } }}>
      <Grid
        container
        alignItems="center"
        sx={{
          display: "flex !important",
          justifyContent: "space-evenly",
          alignItems: "flex-start",
          flexWrap: "nowrap",
          margin: "auto",
        }}
      >
        {/* Left Side - Images */}
        {testimonials?.map((item, index) => (
          <Box
            key={index}
            sx={{
              display: "inline-block",
              justifyContent: "space-between",
              alignItems: "start",
              margin: "1rem auto",
            }}
          >
            <Grid item xs={11} sm={9} margin="auto">
              <Card sx={{ borderRadius: "10px", boxShadow: 3 }}>
                <CardMedia
                  component="img"
                  image={item?.url?.src}
                  alt="Ankita"
                  sx={{
                    borderRadius: "10px",
                    width: "auto",
                    height: "auto",
                    overflow: "hidden",
                    objectFit: "cover",
                  }}
                />
              </Card>
              <Box sx={{ marginTop: "1rem" }}>
                <Typography variant="body1" sx={{ fontStyle: "italic" }}>
                  &#34;{item?.text}&#34;
                </Typography>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: "bold", marginTop: 1 }}
                >
                  {item?.author}
                </Typography>
                <Typography variant="subtitle2" color="textSecondary">
                  {item?.position}
                </Typography>
              </Box>
            </Grid>
          </Box>
        ))}
      </Grid>
    </Box>
  );
};

export default WorkLifeBalance;
